import { Dayjs } from 'dayjs';
import { transformAdminSettingsToRequestValues } from '../../utils';
import { omit } from 'ramda';

const createHM = (dateValue: Dayjs) => {
  return `${dateValue.format('H:mm')}`;
};
export const settingsAtPayload = (formData, settings) => {
  return {
    ...settings,
    settings: transformAdminSettingsToRequestValues(
      {
        ...formData,
        workPattern_defaultMorningStartTime: createHM(
          formData.workPattern_defaultMorningStartTime
        ),
        workPattern_defaultAfternoonStartTime: createHM(
          formData.workPattern_defaultAfternoonStartTime
        )
      },
      settings?.settings
    )
  };
};

export const settingsAtPayloadTravelCost = (formData, settings) => {
  const omittedData = omit(['active'], formData);
  return {
    ...settings,
    active: formData.active,
    settings: transformAdminSettingsToRequestValues(
      {
        ...omittedData,
        travel_exp_max_interval: createHM(formData.travel_exp_max_interval)
      },
      settings?.settings
    )
  };
};
